import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from "mobx";
import moment from "moment";
import toast from "react-hot-toast";
import { DATE_TIME_FORMAT, DATE_TIME_FORMAT_WITHOUT_SECONDS, emptyValue, getEffectiveDateTimeForSchedule } from "../../constants/common-constants";
import FotaStatusEnum from "../../constants/fota-status-enum";
import fotaViewTypeEnum, { ModuleToOpen } from "../../constants/fota-view-type-enum";
import URLConstants from "../../constants/url.constants";
import userTypeEnum from "../../constants/user-type-enum";
import { getLanguageFromLocalStorage, getUserTypeFromLocalStorage } from "../../helpers/local-stotrage-helper";
import { IObservableInitialState, IOption } from "../../models/ICommon";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import { IAddFotaHostConfig, IAddReleaseScheduler, IFotaHostConfig, IFotaHostConfigDetail, IFotaHostConfigList, IFotaHostConfigListVM, IFotaHostFilter, IFotaHostFilterDetails, IFotaHostSchedule, IFotaHostScheduleDetail, IFotaHostScheduleInfo, IFotaHostScheduleList, IFotaHostScheduleListVM, IFotaTntConfigList, IFotaTntConfigListVM } from "../../models/response/IFotaNewResponse";
import { formatMessage } from "../../translations/format-message";
import { addEditFotaHostConfigInitialState } from "../initial-state/add-edit-fota-new-state";
import { initialValues } from '../initial-state/add-edit-schedule-state';
import { getInitialFotaHostConfigListState, getInitialFotaHostScheduleListState, getInitialFotaTntConfigListState } from "../initial-state/get-fota-new-list-state";
import * as baseService from "../service/base-service";

export class FotaTntReleaseStore {
  initialStateValue = {
    success: false,
    error: '',
    inProgress: false
  }
  error: string | null = null;
  inProgress: boolean = false;
  isAddUpdatePopupOpen: boolean = false;
  isFilterPopupOpen: boolean = false;
  isSelectedView: {
    view: fotaViewTypeEnum,
    moduleToOpen: ModuleToOpen,
    isViewChanged: boolean
  } = { view: (getUserTypeFromLocalStorage() == userTypeEnum.SystemUser ? fotaViewTypeEnum.Modem : fotaViewTypeEnum.Host), moduleToOpen: ModuleToOpen.Schedule, isViewChanged: false };



  fotaHostConfigList: IFotaHostConfigListVM = getInitialFotaHostConfigListState;
  fotaJetConfigList: IFotaTntConfigListVM = getInitialFotaTntConfigListState;
  fotaModemConfigList: IFotaTntConfigListVM = getInitialFotaTntConfigListState;
  allHostConfigs: IFotaHostConfig[] = [];
  allJetConfigs: IFotaHostConfig[] = [];
  allModemConfigs: IFotaHostConfig[] = [];
  fotaHostConfigDetailState: IObservableInitialState = { ...this.initialStateValue }
  deleteFotaHostConfigState: IObservableInitialState = { ...this.initialStateValue }
  fotaHostConfigDetail: IFotaHostConfig | undefined = undefined;
  addUpdateFotaState: IObservableInitialState = { ...this.initialStateValue }

  fotaHostScheduleList: IFotaHostScheduleListVM = getInitialFotaHostScheduleListState;
  fotaModemScheduleList: IFotaHostScheduleListVM = getInitialFotaHostScheduleListState;
  fotaJetScheduleList: IFotaHostScheduleListVM = getInitialFotaHostScheduleListState;
  fotaHostScheduleDetailState: IObservableInitialState = { ...this.initialStateValue }
  fotaJetScheduleDetailState: IObservableInitialState = { ...this.initialStateValue }
  fotaModemScheduleDetailState: IObservableInitialState = { ...this.initialStateValue }
  deleteFotaHostScheduleState: IObservableInitialState = { ...this.initialStateValue }
  deleteFotaJetScheduleState: IObservableInitialState = { ...this.initialStateValue }
  deleteFotaModemScheduleState: IObservableInitialState = { ...this.initialStateValue }
  fotaHostScheduleDetail: IFotaHostSchedule | undefined = undefined;
  fotaJetScheduleDetail: IFotaHostSchedule | undefined = undefined;
  fotaModemScheduleDetail: IFotaHostSchedule | undefined = undefined;

  initialFilter: IFotaHostFilter = {
    SearchBy: -1,
    ScheduleStartDate: "",
    ScheduleEndDate: "",
    ConfigName: "",
    VersionNo: "",
    isFilterActive: false
  }

  filterDetails: IFotaHostFilter = {
    ...this.initialFilter
  }

  constructor() {
    makeObservable(this, {
      inProgress: observable,
      error: observable,
      addUpdateFotaState: observable,

      allHostConfigs: observable,
      allJetConfigs: observable,
      allModemConfigs: observable,
      fotaHostConfigList: observable,
      fotaHostConfigDetail: observable,
      fotaHostConfigDetailState: observable,
      deleteFotaHostConfigState: observable,
      fotaHostScheduleList: observable,
      fotaModemScheduleList: observable,
      fotaJetScheduleList: observable,
      fotaHostScheduleDetail: observable,
      fotaJetScheduleDetail: observable,
      fotaModemScheduleDetail: observable,
      fotaHostScheduleDetailState: observable,
      fotaJetScheduleDetailState: observable,
      fotaModemScheduleDetailState: observable,
      deleteFotaHostScheduleState: observable,
      deleteFotaJetScheduleState: observable,
      deleteFotaModemScheduleState: observable,
      fotaJetConfigList: observable,
      fotaModemConfigList: observable,

      isSelectedView: observable,
      isAddUpdatePopupOpen: observable,
      isFilterPopupOpen: observable,
      filterDetails: observable,

      GetFotaHostConfigListService: action,
      GetFotaHostConfigByIdService: action,
      GetAllHostConfigsService: action,
      AddFotaHostConfigService: action,
      UpdateFotaHostConfigService: action,
      DeleteFotaHostConfigService: action,

      GetFotaHostScheduleListService: action,
      GetFotaHostScheduleByIdService: action,
      GetFotaJetScheduleByIdService: action,
      GetFotaModemScheduleByIdService: action,
      AddFotaHostScheduleService: action,
      AddFotaJetScheduleService: action,
      AddFotaModemScheduleService: action,
      UpdateFotaHostScheduleService: action,
      UpdateFotaJetScheduleService: action,
      UpdateFotaModemScheduleService: action,
      DeleteFotaHostScheduleService: action,
      DeleteFotaJetScheduleService: action,
      DeleteFotaModemScheduleService: action,

      GetJetConfigListService: action,
      GetModemConfigListService: action,
      getJetConfigList: computed,
      getModemConfigList: computed,

      reset: action,
      resetAddUpdateFotaState: action,

      resetFotaHostConfigState: action,
      resetDeleteFotaHostConfigState: action,
      resetFotaHostScheduleState: action,
      resetDeleteFotaHostScheduleState: action,
      resetDeleteFotaJetScheduleState: action,
      resetDeleteFotaModemScheduleState: action,
      setSelectedView: action,
      setIsAddUpdatePopupOpen: action,
      setIsFilterPopupOpen: action,

      getFotaHostConfigList: computed,
      getFotaHostConfigDetail: computed,
      getFotaHostConfigInfo: computed,
      getFotaHostScheduleList: computed,
      getFotaModemScheduleList: computed,
      getFotaJetScheduleList: computed,
      getFotaHostScheduleDetail: computed,
      getFotaJetScheduleDetail: computed,
      getFotaModemScheduleDetail: computed,
      getFotaHostScheduleInfo: computed,
      getFotaJetScheduleInfo: computed,
      getFotaModemScheduleInfo: computed,
      allAvailableConfigs: computed,
    });
  }

  /**
   * Fetches a list of Fota items.
   * @param currentPage - Current page number.
   * @param pageSize - Number of items per page.
   */
  GetFotaHostConfigListService = (currentPage: number, pageSize: number) => {
    runInAction(() => (this.inProgress = true));
    let url = `${URLConstants.GetFotaHostConfigList}?PageNo=${currentPage}&PageSize=${pageSize}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaHostConfigListVM>>) => {
        if (response.data.Error) {
          runInAction(
            () => (this.error = response.data.Message)
          );
        } else {
          runInAction(() => {
            this.fotaHostConfigList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        runInAction(() => (this.error = err));
      })
      .finally(() => {
        runInAction(() => (this.inProgress = false));
      });
  };

  /**
    * This function is used to map fotaHostConfigList to Fota List suitable for Grid Component.
    * @returns Initial Fota Details
    */
  get getFotaHostConfigList(): IFotaHostConfigList[] {
    if (this.fotaHostConfigList && this.fotaHostConfigList?.Configs.length > 0)
      return this.fotaHostConfigList?.Configs.map((fota) => {
        let language = getLanguageFromLocalStorage();
        return {
          Id: fota.Id,
          Version: fota.Version,
          ConfigName: fota.ConfigName || "",
          Description: fota.Description ? fota.Description : "",
          FileName: fota.FileName ? fota.FileName : emptyValue,
          FileType: fota.FileType,
          File: fota.File ? fota.File : "",
          CreatedBy: fota.CreatedBy,
          UpdatedBy: fota.UpdatedBy,
          CreatedDate: fota.CreatedDate ? moment(fota.CreatedDate).format(DATE_TIME_FORMAT) : "",
          UpdatedDate: fota.UpdatedDate ? moment(fota.UpdatedDate).format(DATE_TIME_FORMAT) : "",
          Language: language,
          isEdit: true,
          isData: true,
          isDelete: true,
          isSchedule: true,
          isHistore: true,
        }
      })
    return [];
  }

  GetJetConfigListService = (currentPage: number, pageSize: number) => {
    runInAction(() => (this.inProgress = true));
    let url = `${URLConstants.GetEffectedJetConfigList}?PageNo=${currentPage}&PageSize=${pageSize}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaTntConfigListVM>>) => {
        if (response.data.Error) {
          runInAction(
            () => (this.error = response.data.Message)
          );
        } else {
          runInAction(() => {
            this.fotaJetConfigList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        runInAction(() => (this.error = err));
      })
      .finally(() => {
        runInAction(() => (this.inProgress = false));
      });
  };
  get getJetConfigList(): IFotaTntConfigList[] {
    if (this.fotaJetConfigList && this.fotaJetConfigList?.Configs.length > 0)
      return this.fotaJetConfigList?.Configs.map((fota) => {
        let language = getLanguageFromLocalStorage();
        return {
          Id: fota.Id,
          Version: fota.Version,
          ConfigName: fota.ConfigName || "",
          Description: fota.Description ? fota.Description : "",
          FileName: fota.FileName ? fota.FileName : emptyValue,
          FileType: fota.FileType,
          File: fota.File ? fota.File : "",
          CreatedBy: fota.CreatedBy,
          UpdatedBy: fota.UpdatedBy,
          CreatedDate: fota.CreatedDate ? moment(fota.CreatedDate).format(DATE_TIME_FORMAT) : "",
          UpdatedDate: fota.UpdatedDate ? moment(fota.UpdatedDate).format(DATE_TIME_FORMAT) : "",
          Language: language
        }
      })
    return [];
  }

  GetModemConfigListService = (currentPage: number, pageSize: number) => {
    runInAction(() => (this.inProgress = true));
    let url = `${URLConstants.GetEffectedModemConfigList}?PageNo=${currentPage}&PageSize=${pageSize}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaTntConfigListVM>>) => {
        if (response.data.Error) {
          runInAction(
            () => (this.error = response.data.Message)
          );
        } else {
          runInAction(() => {
            this.fotaModemConfigList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        runInAction(() => (this.error = err));
      })
      .finally(() => {
        runInAction(() => (this.inProgress = false));
      });
  };

  get getModemConfigList(): IFotaTntConfigList[] {
    if (this.fotaModemConfigList && this.fotaModemConfigList?.Configs.length > 0)
      return this.fotaModemConfigList?.Configs.map((fota) => {
        let language = getLanguageFromLocalStorage();
        return {
          Id: fota.Id,
          Version: fota.Version,
          ConfigName: fota.ConfigName || "",
          Description: fota.Description ? fota.Description : "",
          FileName: fota.FileName ? fota.FileName : emptyValue,
          FileType: fota.FileType,
          File: fota.File ? fota.File : "",
          CreatedBy: fota.CreatedBy,
          UpdatedBy: fota.UpdatedBy,
          CreatedDate: fota.CreatedDate ? moment(fota.CreatedDate).format(DATE_TIME_FORMAT) : "",
          UpdatedDate: fota.UpdatedDate ? moment(fota.UpdatedDate).format(DATE_TIME_FORMAT) : "",
          Language: language
        }
      })
    return [];
  }

  /**
   * Fetches Fota item details by ID.
   * @param id - ID of the Fota item.
   */
  GetFotaHostConfigByIdService = (id: number) => {
    runInAction(() => (this.fotaHostConfigDetailState.inProgress = true));
    const url = `${URLConstants.FotaHostConfig}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaHostConfig>>) => {
        if (response.data.Error) {
          // runInAction(
          //   () => (this.fotaHostConfigDetailState.error = response.data.Message)
          // );
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.fotaHostConfigDetail = {
              ...response.data.Data,
            };
            this.fotaHostConfigDetailState.success = true;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err));
        // runInAction(() => (this.fotaHostConfigDetailState.error = err));
      })
      .finally(() => {
        runInAction(() => (this.fotaHostConfigDetailState.inProgress = false));
      });
  };


  /**
   * Returns fotaHostConfigDetailDetail which were fetched by Id
   */
  get getFotaHostConfigDetail(): IAddFotaHostConfig {
    if (this.fotaHostConfigDetail)
      return {
        ...this.fotaHostConfigDetail,
        File: "",
        FileContent: this.fotaHostConfigDetail?.File ? this.fotaHostConfigDetail?.File : "",
        FileName: "",
        IsCustomFileNameWithExtension: false,
        IsCustomFileNameWithoutExtension: false,
        WantToUpdateFile: "false",
      };
    else
      return { ...addEditFotaHostConfigInitialState }
  }

  /**
   * Returns fotaHostConfigDetailDetail which were fetched by Id
   */
  get getFotaHostConfigInfo(): IFotaHostConfig | undefined {
    if (this.fotaHostConfigDetail)
      return {
        Id: this.fotaHostConfigDetail.Id,
        Version: this.fotaHostConfigDetail.Version,
        ConfigName: this.fotaHostConfigDetail.ConfigName || "",
        Description: this.fotaHostConfigDetail.Description ? this.fotaHostConfigDetail.Description : "",
        FileName: this.fotaHostConfigDetail.FileName ? this.fotaHostConfigDetail.FileName : emptyValue,
        FileType: this.fotaHostConfigDetail.FileType,
        File: this.fotaHostConfigDetail.File ? this.fotaHostConfigDetail.File : "",
        CreatedBy: this.fotaHostConfigDetail.CreatedBy,
        UpdatedBy: this.fotaHostConfigDetail.UpdatedBy,
        CreatedDate: this.fotaHostConfigDetail.CreatedDate ? moment(this.fotaHostConfigDetail.CreatedDate).format(DATE_TIME_FORMAT) : "",
        UpdatedDate: this.fotaHostConfigDetail.UpdatedDate ? moment(this.fotaHostConfigDetail.UpdatedDate).format(DATE_TIME_FORMAT) : "",

      };
  }

  resetFotaHostConfigState = () => {
    this.fotaHostConfigDetail = undefined;
    this.fotaHostConfigDetailState = { ...this.initialStateValue };
  }

  /**
   * This function is used to Get All Host Config data from API.
   * @returns
   */
  GetAllHostConfigsService = () => {
    this.inProgress = true;
    const url = URLConstants.GetAllFotaHostConfig;
    return baseService.getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<Array<IFotaHostConfig>>>) => {
        if (response.data.Error) {
          this.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        }
        else {
          this.allHostConfigs = response.data.Data;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
      })
      .finally(action(() => { this.inProgress = false; }));
  }

  /**
  * This function is used to map available config List for Add schedule Component.
  * @returns all config list
  */
  get allAvailableConfigs(): IOption[] {
    const options: IOption[] = [{
      id: -1,
      value: "please_select",
      disabled: false
    }];
    if (this.allHostConfigs && this.allHostConfigs?.length > 0)
      this.allHostConfigs.map((config) => {
        options.push({
          id: config.Id,
          value: config.ConfigName,
        })
      })
    return options;
  }

  GetAllJetConfigsService = () => {
    this.inProgress = true;
    const url = URLConstants.GetAllFotaJetConfig;
    return baseService.getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<Array<IFotaHostConfig>>>) => {
        if (response.data.Error) {
          this.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        }
        else {
          this.allJetConfigs = response.data.Data;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
      })
      .finally(action(() => { this.inProgress = false; }));
  }
  /**
* This function is used to map available config List for Add schedule Component.
* @returns all config list
*/
  get allAvailableJetConfigs(): IOption[] {
    const options: IOption[] = [{
      id: -1,
      value: "please_select",
      disabled: false
    }];
    if (this.allJetConfigs && this.allJetConfigs?.length > 0)
      this.allJetConfigs.map((config) => {
        options.push({
          id: config.Id,
          value: config.ConfigName,
        })
      })
    return options;
  }

  GetAllModemConfigsService = () => {
    this.inProgress = true;
    const url = URLConstants.GetAllFotaModemConfig;
    return baseService.getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<Array<IFotaHostConfig>>>) => {
        if (response.data.Error) {
          this.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        }
        else {
          this.allModemConfigs = response.data.Data;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
      })
      .finally(action(() => { this.inProgress = false; }));
  }

  get allAvailableModemConfigs(): IOption[] {
    const options: IOption[] = [{
      id: -1,
      value: "please_select",
      disabled: false
    }];
    if (this.allModemConfigs && this.allModemConfigs?.length > 0)
      this.allModemConfigs.map((config) => {
        options.push({
          id: config.Id,
          value: config.ConfigName,
        })
      })
    return options;
  }

  /**
   * Adds or updates a Fota for SystemAdmin.
   * @param data - Fota item data.
   */
  AddFotaHostConfigService = (data: IFotaHostConfigDetail) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaHostConfig;
    return baseService.postRequest(url, { ...data }).then(
      (
        response: IApiResponse<IApiSuccessResponse<boolean>>
      ) => {
        if (response.data.Error) {
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateFotaState.success = true;
        }
      }
    )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  /**
   * Updates a Fota for SystemAdmin.
   * @param data - Fota item data.
   */
  UpdateFotaHostConfigService = (data: IFotaHostConfigDetail, id: number) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaHostConfig;
    return baseService.putRequest(url, { ...data, Id: id })
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            toast.error(formatMessage(response.data.Message));
          } else {
            this.addUpdateFotaState.success = true;
          }
        }
      )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  resetAddUpdateFotaState = () => {
    this.addUpdateFotaState = { ...this.initialStateValue };
  }

  /**
    * This function is used to Delete User by calling an API.
    * @param id : The User Identifier
    * @returns 
    */
  DeleteFotaHostConfigService = (id: number) => {
    this.deleteFotaHostConfigState.inProgress = true;
    let url = `${URLConstants.FotaHostConfig}/${id}`;
    return baseService.deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteFotaHostConfigState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        }
        else this.deleteFotaHostConfigState.success = true;
      })
      .catch((err: string) => {
        this.deleteFotaHostConfigState.error = err;
      }).finally(action(() => { this.deleteFotaHostConfigState.inProgress = false; }));
  }

  resetDeleteFotaHostConfigState = () => {
    this.deleteFotaHostConfigState = { ...this.initialStateValue };
  };

  /**
   * Fetches a list of Fota items.
   * @param currentPage - Current page number.
   * @param pageSize - Number of items per page.
   */
  GetFotaHostScheduleListService = (currentPage: number, pageSize: number, filter: IFotaHostFilterDetails) => {
    runInAction(() => (this.inProgress = true));
    let url = `${URLConstants.GetFotaHostSchedulerList}`;
    let tempSearchBy: number = typeof filter.SearchBy === "string" ? parseInt(filter.SearchBy) : filter.SearchBy;
    let requestBody = {
      SearchBy: tempSearchBy > 0 ? tempSearchBy : 0,
      ScheduleStartDate: tempSearchBy === 1 ? filter.ScheduleStartDate : null,
      ScheduleEndDate: tempSearchBy === 1 ? filter.ScheduleEndDate : null,
      ConfigName: tempSearchBy === 2 ? filter.ConfigName : "",
      VersionNo: tempSearchBy === 3 ? filter.VersionNo : "",
      PagingDetails: {
        PageNo: currentPage,
        PageSize: pageSize,
        TotalPages: 0,
        TotalRecords: 0
      },
    }
    return baseService
      .postRequest(url, requestBody)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaHostScheduleListVM>>) => {
        if (response.data.Error) {
          runInAction(
            () => (this.error = response.data.Message)
          );
        } else {
          runInAction(() => {
            this.fotaHostScheduleList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        runInAction(() => (this.error = err));
      })
      .finally(() => {
        runInAction(() => (this.inProgress = false));
      });
  };

  /**
    * This function is used to map fotaHostScheduleList to Fota List suitable for Grid Component.
    * @returns Initial Fota Details
    */
  get getFotaHostScheduleList(): IFotaHostScheduleList[] {
    if (this.fotaHostScheduleList && this.fotaHostScheduleList?.Schedules.length > 0)
      return this.fotaHostScheduleList.Schedules.map((fota) => {
        const language = getLanguageFromLocalStorage();
        const status = fota.IsScheduleAborted ? FotaStatusEnum.Aborted : (fota.ScheduleStatus?.Status ?? FotaStatusEnum.None);

        const isEdit =
          status === FotaStatusEnum.Pending;

        const isDelete =
          status === FotaStatusEnum.Pending ||
          status === FotaStatusEnum.Success ||
          status === FotaStatusEnum.Aborted ||
          status === FotaStatusEnum.Failed ||
          status === FotaStatusEnum.None;

        const isHistory =
          true; // Always enabled (View)

        const isAbort =
          status === FotaStatusEnum.Initiated ||
          status === FotaStatusEnum.InProgress;

        return {
          ...fota,
          Id: fota.Id,
          ConfigVersion: fota.Config?.Version ?? "",
          ConfigName: fota.Config?.ConfigName ?? "",
          FileName: fota.Config?.FileName ?? "",
          ConfigDescription: fota.Config?.Description ?? "",
          ScheduleDate: fota.ScheduleDate ? moment(fota.ScheduleDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
          ScheduleExpirationDate: fota.ScheduleExpirationDate ? moment(fota.ScheduleExpirationDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
          ScheduleDurationDay: fota.ScheduleDurationDay || 0,
          IsScheduleAborted: fota.IsScheduleAborted || false,
          Status: status,
          Progress: fota.ScheduleStatus?.Progress ?? 0,
          LastStatusUpdatedDateTimestamp: fota.ScheduleStatus?.LastStatusUpdatedDateTimestamp
            ? moment(fota.ScheduleStatus.LastStatusUpdatedDateTimestamp).format(DATE_TIME_FORMAT)
            : "",
          Description: fota.Description ?? "",
          CreatedBy: fota.CreatedBy,
          UpdatedBy: fota.UpdatedBy,
          CreatedDate: fota.CreatedDate ? moment(fota.CreatedDate).format(DATE_TIME_FORMAT) : "",
          UpdatedDate: fota.UpdatedDate ? moment(fota.UpdatedDate).format(DATE_TIME_FORMAT) : "",
          Language: language,

          isEdit,
          isDelete,
          isHistory,
          isAbort,

          isData: true,
          isSchedule: true,
        };
      });

    return [];
  }

  GetFotaJetScheduleListService = (currentPage: number, pageSize: number, filter: IFotaHostFilterDetails) => {
    runInAction(() => (this.inProgress = true));
    let url = `${URLConstants.GetFotaJetSchedulerList}`;
    let tempSearchBy: number = typeof filter.SearchBy === "string" ? parseInt(filter.SearchBy) : filter.SearchBy;
    let requestBody = {
      SearchBy: tempSearchBy > 0 ? tempSearchBy : 0,
      ScheduleStartDate: tempSearchBy === 1 ? filter.ScheduleStartDate : null,
      ScheduleEndDate: tempSearchBy === 1 ? filter.ScheduleEndDate : null,
      ConfigName: tempSearchBy === 2 ? filter.ConfigName : "",
      VersionNo: tempSearchBy === 3 ? filter.VersionNo : "",
      PagingDetails: {
        PageNo: currentPage,
        PageSize: pageSize,
        TotalPages: 0,
        TotalRecords: 0
      },
    }
    return baseService
      .postRequest(url, requestBody)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaHostScheduleListVM>>) => {
        if (response.data.Error) {
          runInAction(
            () => (this.error = response.data.Message)
          );
        } else {
          runInAction(() => {
            this.fotaJetScheduleList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        runInAction(() => (this.error = err));
      })
      .finally(() => {
        runInAction(() => (this.inProgress = false));
      });
  };
  get getFotaJetScheduleList(): IFotaHostScheduleList[] {
    if (this.fotaJetScheduleList && this.fotaJetScheduleList?.Schedules.length > 0)
      return this.fotaJetScheduleList.Schedules.map((fota) => {
        const language = getLanguageFromLocalStorage();
        const status = fota.IsScheduleAborted ? FotaStatusEnum.Aborted : (fota.ScheduleStatus?.Status ?? FotaStatusEnum.None);

        const isEdit =
          status === FotaStatusEnum.Pending;

        const isDelete =
          status === FotaStatusEnum.Pending ||
          status === FotaStatusEnum.Success ||
          status === FotaStatusEnum.Aborted ||
          status === FotaStatusEnum.Failed ||
          status === FotaStatusEnum.None;

        const isHistory =
          true; // Always enabled (View)

        const isAbort =
          status === FotaStatusEnum.Initiated ||
          status === FotaStatusEnum.InProgress;

        return {
          ...fota,
          Id: fota.Id,
          ConfigVersion: fota.Config?.Version ?? "",
          ConfigName: fota.Config?.ConfigName ?? "",
          FileName: fota.Config?.FileName ?? "",
          ConfigDescription: fota.Config?.Description ?? "",
          ScheduleDate: fota.ScheduleDate ? moment(fota.ScheduleDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
          ScheduleExpirationDate: fota.ScheduleExpirationDate ? moment(fota.ScheduleExpirationDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
          ScheduleDurationDay: fota.ScheduleDurationDay || 0,
          IsScheduleAborted: fota.IsScheduleAborted || false,
          Status: status,
          Progress: fota.ScheduleStatus?.Progress ?? 0,
          LastStatusUpdatedDateTimestamp: fota.ScheduleStatus?.LastStatusUpdatedDateTimestamp
            ? moment(fota.ScheduleStatus.LastStatusUpdatedDateTimestamp).format(DATE_TIME_FORMAT)
            : "",
          Description: fota.Description ?? "",
          CreatedBy: fota.CreatedBy,
          UpdatedBy: fota.UpdatedBy,
          CreatedDate: fota.CreatedDate ? moment(fota.CreatedDate).format(DATE_TIME_FORMAT) : "",
          UpdatedDate: fota.UpdatedDate ? moment(fota.UpdatedDate).format(DATE_TIME_FORMAT) : "",
          Language: language,

          isEdit,
          isDelete,
          isHistory,
          isAbort,

          isData: true,
          isSchedule: true,
        };
      });

    return [];
  }

  GetFotaModemScheduleListService = (currentPage: number, pageSize: number, filter: IFotaHostFilterDetails) => {
    runInAction(() => (this.inProgress = true));
    let url = `${URLConstants.GetFotaModemSchedulerList}`;
    let tempSearchBy: number = typeof filter.SearchBy === "string" ? parseInt(filter.SearchBy) : filter.SearchBy;
    let requestBody = {
      SearchBy: tempSearchBy > 0 ? tempSearchBy : 0,
      ScheduleStartDate: tempSearchBy === 1 ? filter.ScheduleStartDate : null,
      ScheduleEndDate: tempSearchBy === 1 ? filter.ScheduleEndDate : null,
      ConfigName: tempSearchBy === 2 ? filter.ConfigName : "",
      VersionNo: tempSearchBy === 3 ? filter.VersionNo : "",
      PagingDetails: {
        PageNo: currentPage,
        PageSize: pageSize,
        TotalPages: 0,
        TotalRecords: 0
      },
    }
    return baseService
      .postRequest(url, requestBody)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaHostScheduleListVM>>) => {
        if (response.data.Error) {
          runInAction(
            () => (this.error = response.data.Message)
          );
        } else {
          runInAction(() => {
            this.fotaModemScheduleList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        runInAction(() => (this.error = err));
      })
      .finally(() => {
        runInAction(() => (this.inProgress = false));
      });
  };

  get getFotaModemScheduleList(): IFotaHostScheduleList[] {
    if (this.fotaModemScheduleList && this.fotaModemScheduleList?.Schedules.length > 0)
      return this.fotaModemScheduleList.Schedules.map((fota) => {
        const language = getLanguageFromLocalStorage();
        const status = fota.IsScheduleAborted ? FotaStatusEnum.Aborted : (fota.ScheduleStatus?.Status ?? FotaStatusEnum.None);

        const isEdit =
          status === FotaStatusEnum.Pending;

        const isDelete =
          status === FotaStatusEnum.Pending ||
          status === FotaStatusEnum.Success ||
          status === FotaStatusEnum.Aborted ||
          status === FotaStatusEnum.Failed ||
          status === FotaStatusEnum.None;

        const isHistory =
          true; // Always enabled (View)

        const isAbort =
          status === FotaStatusEnum.Initiated ||
          status === FotaStatusEnum.InProgress;

        return {
          ...fota,
          Id: fota.Id,
          ConfigVersion: fota.Config?.Version ?? "",
          ConfigName: fota.Config?.ConfigName ?? "",
          FileName: fota.Config?.FileName ?? "",
          ConfigDescription: fota.Config?.Description ?? "",
          ScheduleDate: fota.ScheduleDate ? moment(fota.ScheduleDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
          ScheduleExpirationDate: fota.ScheduleExpirationDate ? moment(fota.ScheduleExpirationDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
          ScheduleDurationDay: fota.ScheduleDurationDay || 0,
          IsScheduleAborted: fota.IsScheduleAborted || false,
          Status: status,
          Progress: fota.ScheduleStatus?.Progress ?? 0,
          LastStatusUpdatedDateTimestamp: fota.ScheduleStatus?.LastStatusUpdatedDateTimestamp
            ? moment(fota.ScheduleStatus.LastStatusUpdatedDateTimestamp).format(DATE_TIME_FORMAT)
            : "",
          Description: fota.Description ?? "",
          CreatedBy: fota.CreatedBy,
          UpdatedBy: fota.UpdatedBy,
          CreatedDate: fota.CreatedDate ? moment(fota.CreatedDate).format(DATE_TIME_FORMAT) : "",
          UpdatedDate: fota.UpdatedDate ? moment(fota.UpdatedDate).format(DATE_TIME_FORMAT) : "",
          Language: language,

          isEdit,
          isDelete,
          isHistory,
          isAbort,

          isData: true,
          isSchedule: true,
        };
      });

    return [];
  }

  /**
   * Fetches Fota item details by ID.
   * @param id - ID of the Fota item.
   */
  GetFotaHostScheduleByIdService = (id: number) => {
    runInAction(() => (this.fotaHostScheduleDetailState.inProgress = true));
    const url = `${URLConstants.FotaHostScheduler}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaHostSchedule>>) => {
        if (response.data.Error) {
          // runInAction(
          //   () => (this.fotaHostScheduleDetailState.error = response.data.Message)
          // );
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.fotaHostScheduleDetail = {
              ...response.data.Data,
            };
            this.fotaHostScheduleDetailState.success = true;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err));
        // runInAction(() => (this.fotaHostScheduleDetailState.error = err));
      })
      .finally(() => {
        runInAction(() => (this.fotaHostScheduleDetailState.inProgress = false));
      });
  };

  /**
   * Returns fotaHostScheduleDetail which were fetched by Id
   */
  get getFotaHostScheduleDetail(): IAddReleaseScheduler {
    if (this.fotaHostScheduleDetail)
      return {
        ConfigId: this.fotaHostScheduleDetail.Config ? this.fotaHostScheduleDetail.Config.Id : -1,
        ScheduleDate: (this.fotaHostScheduleDetail.ScheduleDate && this.fotaHostScheduleDetail.ScheduleDate !== "1970-01-01") ? moment(this.fotaHostScheduleDetail.ScheduleDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
        Description: this.fotaHostScheduleDetail.Description,
        IsAppliedOnGroup: "false",
        GroupIds: [],
        ICCIDs: [],
        ICCIDsFile: "",
        ICCIDsFileContent: "",
        IsUpdateNow: "0",
        WantToUpdateDevices: "false",
        ScheduleDurationDay: 1,

      };
    return { ...initialValues, ScheduleDate: getEffectiveDateTimeForSchedule() };
  }

  /**
   * Returns fotaHostScheduleDetailDetail which were fetched by Id
   */
  get getFotaHostScheduleInfo(): IFotaHostScheduleInfo | undefined {
    if (this.fotaHostScheduleDetail)
      return {
        ...this.fotaHostScheduleDetail,
        Id: this.fotaHostScheduleDetail.Id,
        ConfigVersion: this.fotaHostScheduleDetail?.Config ? this.fotaHostScheduleDetail?.Config.Version : "",
        ConfigName: this.fotaHostScheduleDetail?.Config ? this.fotaHostScheduleDetail?.Config.ConfigName : "",
        ConfigDescription: this.fotaHostScheduleDetail?.Config ? this.fotaHostScheduleDetail?.Config.Description : "",
        ScheduleDate: this.fotaHostScheduleDetail?.ScheduleDate ? moment(this.fotaHostScheduleDetail?.ScheduleDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
        ScheduleDurationDay: this.fotaHostScheduleDetail?.ScheduleDurationDay || 0,
        IsScheduleAborted: this.fotaHostScheduleDetail?.IsScheduleAborted || false,
        Status: this.fotaHostScheduleDetail?.ScheduleStatus ? this.fotaHostScheduleDetail?.ScheduleStatus.Status : 0,
        Progress: this.fotaHostScheduleDetail?.ScheduleStatus ? this.fotaHostScheduleDetail?.ScheduleStatus.Progress : 0,
        LastStatusUpdatedDateTimestamp: (this.fotaHostScheduleDetail?.ScheduleStatus && this.fotaHostScheduleDetail?.ScheduleStatus?.LastStatusUpdatedDateTimestamp) ? moment(this.fotaHostScheduleDetail?.ScheduleStatus.LastStatusUpdatedDateTimestamp).format(DATE_TIME_FORMAT) : "",
        Description: this.fotaHostScheduleDetail?.Description ? this.fotaHostScheduleDetail?.Description : "",
        CreatedBy: this.fotaHostScheduleDetail?.CreatedBy,
        UpdatedBy: this.fotaHostScheduleDetail?.UpdatedBy,
        CreatedDate: this.fotaHostScheduleDetail?.CreatedDate ? moment(this.fotaHostScheduleDetail?.CreatedDate).format(DATE_TIME_FORMAT) : "",
        UpdatedDate: this.fotaHostScheduleDetail?.UpdatedDate ? moment(this.fotaHostScheduleDetail?.UpdatedDate).format(DATE_TIME_FORMAT) : "",
      };
  }

  resetFotaHostScheduleState = () => {
    this.fotaHostScheduleDetail = undefined;
    this.fotaHostScheduleDetailState = { ...this.initialStateValue };
  }

  GetFotaJetScheduleByIdService = (id: number) => {
    runInAction(() => (this.fotaJetScheduleDetailState.inProgress = true));
    const url = `${URLConstants.FotaJetScheduler}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaHostSchedule>>) => {
        if (response.data.Error) {
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.fotaJetScheduleDetail = {
              ...response.data.Data,
            };
            this.fotaJetScheduleDetailState.success = true;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        runInAction(() => (this.fotaJetScheduleDetailState.inProgress = false));
      });
  };

  /**
   * Returns fotaJetScheduleDetail which were fetched by Id
   */
  get getFotaJetScheduleDetail(): IAddReleaseScheduler {
    if (this.fotaJetScheduleDetail)
      return {
        ConfigId: this.fotaJetScheduleDetail.Config ? this.fotaJetScheduleDetail.Config.Id : -1,
        ScheduleDate: (this.fotaJetScheduleDetail.ScheduleDate && this.fotaJetScheduleDetail.ScheduleDate !== "1970-01-01") ? moment(this.fotaJetScheduleDetail.ScheduleDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
        Description: this.fotaJetScheduleDetail.Description,
        IsAppliedOnGroup: "false",
        GroupIds: [],
        ICCIDs: [],
        ICCIDsFile: "",
        ICCIDsFileContent: "",
        IsUpdateNow: "0",
        WantToUpdateDevices: "false",
        ScheduleDurationDay: 1,

      };
    return { ...initialValues, ScheduleDate: getEffectiveDateTimeForSchedule() };
  }

  get getFotaJetScheduleInfo(): IFotaHostScheduleInfo | undefined {
    if (this.fotaJetScheduleDetail)
      return {
        ...this.fotaJetScheduleDetail,
        Id: this.fotaJetScheduleDetail.Id,
        ConfigVersion: this.fotaJetScheduleDetail?.Config ? this.fotaJetScheduleDetail?.Config.Version : "",
        ConfigName: this.fotaJetScheduleDetail?.Config ? this.fotaJetScheduleDetail?.Config.ConfigName : "",
        ConfigDescription: this.fotaJetScheduleDetail?.Config ? this.fotaJetScheduleDetail?.Config.Description : "",
        ScheduleDate: this.fotaJetScheduleDetail?.ScheduleDate ? moment(this.fotaJetScheduleDetail?.ScheduleDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
        ScheduleDurationDay: this.fotaJetScheduleDetail?.ScheduleDurationDay || 0,
        IsScheduleAborted: this.fotaJetScheduleDetail?.IsScheduleAborted || false,
        Status: this.fotaJetScheduleDetail?.ScheduleStatus ? this.fotaJetScheduleDetail?.ScheduleStatus.Status : 0,
        Progress: this.fotaJetScheduleDetail?.ScheduleStatus ? this.fotaJetScheduleDetail?.ScheduleStatus.Progress : 0,
        LastStatusUpdatedDateTimestamp: (this.fotaJetScheduleDetail?.ScheduleStatus && this.fotaJetScheduleDetail?.ScheduleStatus?.LastStatusUpdatedDateTimestamp) ? moment(this.fotaJetScheduleDetail?.ScheduleStatus.LastStatusUpdatedDateTimestamp).format(DATE_TIME_FORMAT) : "",
        Description: this.fotaJetScheduleDetail?.Description ? this.fotaJetScheduleDetail?.Description : "",
        CreatedBy: this.fotaJetScheduleDetail?.CreatedBy,
        UpdatedBy: this.fotaJetScheduleDetail?.UpdatedBy,
        CreatedDate: this.fotaJetScheduleDetail?.CreatedDate ? moment(this.fotaJetScheduleDetail?.CreatedDate).format(DATE_TIME_FORMAT) : "",
        UpdatedDate: this.fotaJetScheduleDetail?.UpdatedDate ? moment(this.fotaJetScheduleDetail?.UpdatedDate).format(DATE_TIME_FORMAT) : "",
      };
  }

  resetFotaJetScheduleState = () => {
    this.fotaJetScheduleDetail = undefined;
    this.fotaJetScheduleDetailState = { ...this.initialStateValue };
  }
  resetFotaModemScheduleState = () => {
    this.fotaModemScheduleDetail = undefined;
    this.fotaModemScheduleDetailState = { ...this.initialStateValue };
  }

  GetFotaModemScheduleByIdService = (id: number) => {
    runInAction(() => (this.fotaModemScheduleDetailState.inProgress = true));
    const url = `${URLConstants.FotaModemScheduler}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaHostSchedule>>) => {
        if (response.data.Error) {
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.fotaModemScheduleDetail = {
              ...response.data.Data,
            };
            this.fotaModemScheduleDetailState.success = true;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        runInAction(() => (this.fotaModemScheduleDetailState.inProgress = false));
      });
  };


  get getFotaModemScheduleDetail(): IAddReleaseScheduler {
    if (this.fotaModemScheduleDetail)
      return {
        ConfigId: this.fotaModemScheduleDetail.Config ? this.fotaModemScheduleDetail.Config.Id : -1,
        ScheduleDate: (this.fotaModemScheduleDetail.ScheduleDate && this.fotaModemScheduleDetail.ScheduleDate !== "1970-01-01") ? moment(this.fotaModemScheduleDetail.ScheduleDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
        Description: this.fotaModemScheduleDetail.Description,
        IsAppliedOnGroup: "false",
        GroupIds: [],
        ICCIDs: [],
        ICCIDsFile: "",
        ICCIDsFileContent: "",
        IsUpdateNow: "0",
        WantToUpdateDevices: "false",
        ScheduleDurationDay: 1,

      };
    return { ...initialValues, ScheduleDate: getEffectiveDateTimeForSchedule() };
  }

  get getFotaModemScheduleInfo(): IFotaHostScheduleInfo | undefined {
    if (this.fotaModemScheduleDetail)
      return {
        ...this.fotaModemScheduleDetail,
        Id: this.fotaModemScheduleDetail.Id,
        ConfigVersion: this.fotaModemScheduleDetail?.Config ? this.fotaModemScheduleDetail?.Config.Version : "",
        ConfigName: this.fotaModemScheduleDetail?.Config ? this.fotaModemScheduleDetail?.Config.ConfigName : "",
        ConfigDescription: this.fotaModemScheduleDetail?.Config ? this.fotaModemScheduleDetail?.Config.Description : "",
        ScheduleDate: this.fotaModemScheduleDetail?.ScheduleDate ? moment(this.fotaModemScheduleDetail?.ScheduleDate).format(DATE_TIME_FORMAT_WITHOUT_SECONDS) : "",
        ScheduleDurationDay: this.fotaModemScheduleDetail?.ScheduleDurationDay || 0,
        IsScheduleAborted: this.fotaModemScheduleDetail?.IsScheduleAborted || false,
        Status: this.fotaModemScheduleDetail?.ScheduleStatus ? this.fotaModemScheduleDetail?.ScheduleStatus.Status : 0,
        Progress: this.fotaModemScheduleDetail?.ScheduleStatus ? this.fotaModemScheduleDetail?.ScheduleStatus.Progress : 0,
        LastStatusUpdatedDateTimestamp: (this.fotaModemScheduleDetail?.ScheduleStatus && this.fotaModemScheduleDetail?.ScheduleStatus?.LastStatusUpdatedDateTimestamp) ? moment(this.fotaModemScheduleDetail?.ScheduleStatus.LastStatusUpdatedDateTimestamp).format(DATE_TIME_FORMAT) : "",
        Description: this.fotaModemScheduleDetail?.Description ? this.fotaModemScheduleDetail?.Description : "",
        CreatedBy: this.fotaModemScheduleDetail?.CreatedBy,
        UpdatedBy: this.fotaModemScheduleDetail?.UpdatedBy,
        CreatedDate: this.fotaModemScheduleDetail?.CreatedDate ? moment(this.fotaModemScheduleDetail?.CreatedDate).format(DATE_TIME_FORMAT) : "",
        UpdatedDate: this.fotaModemScheduleDetail?.UpdatedDate ? moment(this.fotaModemScheduleDetail?.UpdatedDate).format(DATE_TIME_FORMAT) : "",
      };
  }

  resetFotaModeScheduleState = () => {
    this.fotaModemScheduleDetail = undefined;
    this.fotaModemScheduleDetailState = { ...this.initialStateValue };
  }

  /**
   * Adds or updates a Fota for SystemAdmin.
   * @param data - Fota item data.
   */
  AddFotaHostScheduleService = (data: IFotaHostScheduleDetail) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaHostScheduler;
    return baseService.postRequest(url, { ...data, OffsetMinutes: moment().utcOffset() }).then(
      (
        response: IApiResponse<IApiSuccessResponse<boolean>>
      ) => {
        if (response.data.Error) {
          let err = response.data.Message
          if (err.includes(":")) {
            let errorMess = err.split(":");
            toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
          } else { toast.error(formatMessage(err)); }
        } else {
          this.addUpdateFotaState.success = true;
        }
      }
    )
      .catch((err: any) => {
        if (err.includes(":")) {
          let errorMess = err.split(":");
          toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
        } else { toast.error(formatMessage(err)); }
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  AddFotaJetScheduleService = (data: IFotaHostScheduleDetail) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaJetScheduler;
    return baseService.postRequest(url, { ...data, OffsetMinutes: moment().utcOffset() }).then(
      (
        response: IApiResponse<IApiSuccessResponse<boolean>>
      ) => {
        if (response.data.Error) {
          let err = response.data.Message
          if (err.includes(":")) {
            let errorMess = err.split(":");
            toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
          } else { toast.error(formatMessage(err)); }
        } else {
          this.addUpdateFotaState.success = true;
        }
      }
    )
      .catch((err: any) => {
        if (err.includes(":")) {
          let errorMess = err.split(":");
          toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
        } else { toast.error(formatMessage(err)); }
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  AddFotaModemScheduleService = (data: IFotaHostScheduleDetail) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaModemScheduler;
    return baseService.postRequest(url, { ...data, OffsetMinutes: moment().utcOffset() }).then(
      (
        response: IApiResponse<IApiSuccessResponse<boolean>>
      ) => {
        if (response.data.Error) {
          let err = response.data.Message
          if (err.includes(":")) {
            let errorMess = err.split(":");
            toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
          } else { toast.error(formatMessage(err)); }
        } else {
          this.addUpdateFotaState.success = true;
        }
      }
    )
      .catch((err: any) => {
        if (err.includes(":")) {
          let errorMess = err.split(":");
          toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
        } else { toast.error(formatMessage(err)); }
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  /**
   * Updates a Fota for SystemAdmin.
   * @param data - Fota item data.
   */
  UpdateFotaHostScheduleService = (data: IFotaHostScheduleDetail, id: number) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaHostScheduler;
    return baseService.putRequest(url, { ...data, Id: id, OffsetMinutes: moment().utcOffset() })
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            let err = response.data.Message
            if (err.includes(":")) {
              let errorMess = err.split(":");
              toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
            } else { toast.error(formatMessage(err)); }
            // toast.error(formatMessage(response.data.Message));
          } else {
            this.addUpdateFotaState.success = true;
          }
        }
      )
      .catch((err: any) => {
        if (err.includes(":")) {
          let errorMess = err.split(":");
          toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
        } else { toast.error(formatMessage(err)); }
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  UpdateFotaJetScheduleService = (data: IFotaHostScheduleDetail, id: number) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaJetScheduler;
    return baseService.putRequest(url, { ...data, Id: id, OffsetMinutes: moment().utcOffset() })
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            let err = response.data.Message
            if (err.includes(":")) {
              let errorMess = err.split(":");
              toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
            } else { toast.error(formatMessage(err)); }
          } else {
            this.addUpdateFotaState.success = true;
          }
        }
      )
      .catch((err: any) => {
        if (err.includes(":")) {
          let errorMess = err.split(":");
          toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
        } else { toast.error(formatMessage(err)); }
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  UpdateFotaModemScheduleService = (data: IFotaHostScheduleDetail, id: number) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaModemScheduler;
    return baseService.putRequest(url, { ...data, Id: id, OffsetMinutes: moment().utcOffset() })
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            let err = response.data.Message
            if (err.includes(":")) {
              let errorMess = err.split(":");
              toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
            } else { toast.error(formatMessage(err)); }
          } else {
            this.addUpdateFotaState.success = true;
          }
        }
      )
      .catch((err: any) => {
        if (err.includes(":")) {
          let errorMess = err.split(":");
          toast.error(formatMessage(errorMess[0]?.trim()) + " : " + errorMess[1]);
        } else { toast.error(formatMessage(err)); }
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  /**
    * This function is used to Delete host schedule by calling an API.
    * @param id : The User Identifier
    * @returns 
    */
  DeleteFotaHostScheduleService = (id: number) => {
    this.deleteFotaHostScheduleState.inProgress = true;
    let url = `${URLConstants.FotaHostScheduler}/${id}`;
    return baseService.deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteFotaHostScheduleState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        }
        else this.deleteFotaHostScheduleState.success = true;
      })
      .catch((err: string) => {
        this.deleteFotaHostScheduleState.error = err;
      }).finally(action(() => { this.deleteFotaHostScheduleState.inProgress = false; }));
  }


  resetDeleteFotaHostScheduleState = () => {
    this.deleteFotaHostScheduleState = { ...this.initialStateValue };
  };

  DeleteFotaJetScheduleService = (id: number) => {
    this.deleteFotaJetScheduleState.inProgress = true;
    let url = `${URLConstants.FotaJetScheduler}/${id}`;
    return baseService.deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteFotaJetScheduleState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        }
        else this.deleteFotaJetScheduleState.success = true;
      })
      .catch((err: string) => {
        this.deleteFotaJetScheduleState.error = err;
      }).finally(action(() => { this.deleteFotaJetScheduleState.inProgress = false; }));
  }

  resetDeleteFotaJetScheduleState = () => {
    this.deleteFotaJetScheduleState = { ...this.initialStateValue };
  };

  DeleteFotaModemScheduleService = (id: number) => {
    this.deleteFotaModemScheduleState.inProgress = true;
    let url = `${URLConstants.FotaModemScheduler}/${id}`;
    return baseService.deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteFotaModemScheduleState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        }
        else this.deleteFotaModemScheduleState.success = true;
      })
      .catch((err: string) => {
        this.deleteFotaModemScheduleState.error = err;
      }).finally(action(() => { this.deleteFotaModemScheduleState.inProgress = false; }));
  }

  resetDeleteFotaModemScheduleState = () => {
    this.deleteFotaModemScheduleState = { ...this.initialStateValue };
  };
  /**
   * Resets all observables to their initial values.
   */
  reset = () => {
    this.addUpdateFotaState = { ...this.initialStateValue };
  };

  setSelectedView = (data: { view: fotaViewTypeEnum, moduleToOpen: ModuleToOpen, isViewChanged: boolean }) => {
    this.isSelectedView = { ...data };
    localStorage.setItem('mzl_selected_view', JSON.stringify({ view: data.view, moduleToOpen: data.moduleToOpen }))
  }

  setIsAddUpdatePopupOpen = (flag: boolean) => {
    this.isAddUpdatePopupOpen = flag
  }

  setIsFilterPopupOpen = (flag: boolean) => {
    this.isFilterPopupOpen = flag
  }

  setFilterDetail = (filter: IFotaHostFilter) => {
    this.filterDetails = { ...filter };
  }

}
const fotaTntReleaseStore = new FotaTntReleaseStore();
export default fotaTntReleaseStore;
